import React from "react";
import { useTranslation } from "react-i18next";
import { InputSwitcher, ButtonBase, ButtonIconCancel } from "../../../common/components/form";

import * as API from "../../lib/api";
import datefmt from "../../lib/datefmt";

export default function ProjectConversion(props) {
    const {
        show,
        onShowConversionClick,

        onChangeStart,
        onChangeEnd,

        data,
        data: {
            id: id_project,
            domain,
            variables,
            variables: { useConversion: _active },
        },
    } = props;

    const { t } = useTranslation();

    const active = _active === undefined ? false : _active;

    const [wait, setWait] = React.useState(false);
    const [stats, setStats] = React.useState({});

    const refRoot = React.useRef();
    const refWaitCalculationsMessage = React.useRef();

    React.useEffect(() => {
        // Load + Loop
        const domRoot = refRoot.current;

        async function loop() {
            await loadConversionStats();
            active && (domRoot.loopTimeout = setTimeout(loop, 30000));
        }
        domRoot.loopTimeout && clearTimeout(domRoot.loopTimeout);
        show && active && loop();

        return () => {
            domRoot.loopTimeout && clearTimeout(domRoot.loopTimeout);
        };
    }, [show, id_project, active]);

    async function loadConversionStats() {
        setWait(true);

        const request = async () => {
            const response = await API.ProjectConversionStats(domain);

            if (response?.stats === undefined) {
                return await request();
            }

            return response;
        };

        const { stats } = await request();

        setStats({ ...stats });
        setWait(false);
    }

    function change(active) {
        onChangeStart && onChangeStart();

        return API.ProjectUpdate({
            id_project,
            ...data,
            variables: { ...variables, useConversion: active },
        })
            .then(res => {
                if (!res?.ok) {
                    console.warn(res);
                    return;
                }

                return API.CompileRender(domain);
            })

            .finally(() => onChangeEnd && onChangeEnd());
    }

    function onChange(checked) {
        change(checked);
    }

    function onStartExperimentClick() {
        change(!active);
    }

    const launch = stats?.launch;
    const inactive = stats?.inactive;
    const complete = stats?.complete;
    const stage = stats?.stage > 0 ? stats?.stage : null;

    let CL = ["projects-item-conversion-container"];
    show && CL.push("show");
    CL = CL.join(" ");

    return (
        <div ref={refRoot} className={CL}>
            {/* Conversion actions mobile */}
            <div className="projects-item-conversion-float-actions mobile">
                <ButtonIconCancel className="projects-item-additional-cancel" onClick={() => onShowConversionClick()} />
            </div>

            <div className="project-item-conversion-header">
                <div>
                    <InputSwitcher onChange={(value, checked) => onChange(checked)} checked={active} />
                </div>

                <div>
                    <span>{t("Conversion")}</span>
                </div>
            </div>

            <div className="projects-item-conversion-content" style={{ position: "relative" }}>
                {/* {wait && <div style={{ position: "absolute", top: "-20px" }}>{t("Loading")}...</div>} */}

                {launch && <div>{t("ConversionLaunchAtAbout").replace(/%DATETIME%/g, datefmt(launch, "h:m"))}</div>}

                {inactive && <div>{t("ConversionDisabled")}</div>}

                {stats?.errors?.type === "test-variables" && <ErrorTestVariables tests={stats.errors.tests} />}

                {complete && (
                    <div>
                        {t("ConversionComplete")}

                        <span>
                            ({t("ConversionStage")} {stage})
                        </span>
                    </div>
                )}

                {!complete && stage > 0 && (
                    <div className="project-item-conversion-stats">
                        <div style={{ display: "grid" }}>
                            <span>
                                {t("ConversionStage")}: <b>{stage}</b>
                            </span>

                            <span>
                                {t("ConversionProgress")}:{" "}
                                <b>{Math.floor((1 - stats.uncompleteVisists / stats.totalConversions) * 100)}%</b>
                            </span>

                            <span>
                                {t("ConversionVisits")}: <b>{stats.sessions}</b>
                            </span>
                        </div>

                        <div style={{ display: "grid" }}>
                            <span>
                                {t("ConversionVariants")}: <b>{stats.totalConversions}</b>
                            </span>

                            {stats.uncompleteVisists > 0 && (
                                <span>
                                    {t("ConversionUncomplete")}: <b>{stats.uncompleteVisists}</b>
                                </span>
                            )}

                            {stats.uncompleteVisists === 0 && (
                                <span style={{ textDecoration: "underline" }}>
                                    Waiting for filtering variants at 00:00:00.
                                </span>
                            )}
                        </div>
                    </div>
                )}

                {wait && (
                    <div ref={refWaitCalculationsMessage}>
                        {t("There are calculations going on, it may take some time.")}
                    </div>
                )}
            </div>

            {/* Conversionfloat actions desktop */}
            <div className="projects-item-conversion-float-actions desktop">
                <ButtonIconCancel className="projects-item-additional-cancel" onClick={() => onShowConversionClick()} />
            </div>

            {/* Conversionfloat actions desktop */}
            <div className="projects-item-conversion-actions">
                <ButtonBase invert onClick={() => onStartExperimentClick()}>
                    {active ? t("ConversionStopExperiment") : t("ConversionStartExperiment")}
                </ButtonBase>
            </div>
        </div>
    );
}

function ErrorTestVariables(props) {
    const { tests } = props;

    return (
        <div>
            {Object.entries(tests).map(([varName, { required, name, value, result }]) => {
                if (result === true) {
                    return null;
                }

                return (
                    <div key={varName}>
                        <p>
                            {/* {required && <b>[Required]</b>} */}
                            <b>{name}</b>:{" "}
                            {result === false ? "Bad value" : result === null ? "Empty value" : `Unknown (${result})`}{" "}
                            <i
                                title={JSON.stringify(value)}
                                style={{ textDecoration: "underline dashed", cursor: "pointer" }}
                            >
                                (INFO)
                            </i>
                        </p>
                    </div>
                );
            })}
        </div>
    );
}
